<template>
  <div id="app">
    <v-toast/>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'app',
  beforeMount () {
    if(localStorage.getItem("user")){
      this.initTheme()
      this.setCurrentUser()
    }
  },
  methods: {
    ...mapActions('user', ['setCurrentUser'])
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?5ab83dd2